// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__iMr2i","brand":"Nav_brand__Zmepn","dot":"Nav_dot__0o2Lf","links":"Nav_links__MwC2F","toggle":"Nav_toggle__MuCLN","show":"Nav_show__deGzK"};